import api from "@/lib/api";

export const mediaUrl = (id) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/media/${id}/file?auth=${encodeURIComponent(localStorage.getItem("bt_token") || "")}`;

export async function uploadMedia(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/media", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

export async function listMedia() {
  const { data } = await api.get("/media");
  return data.media || [];
}

export async function deleteMedia(id) {
  await api.delete(`/media/${id}`);
}
